'use strict';

import {theme} from 'core_theme_2';

let paginationTemp = theme.templates.pageinationTemp;
//let warningTemp = theme.templates.warningTemp;
let updatesTemp = theme.templates.updatesTemp;
let modelsTemp = theme.templates.modelsTemp;
let modelTemp = theme.templates.modelTemp;
let trailerTemp = theme.templates.trailerTemp;
let videoTemp = theme.templates.videoTemp;
let imageTemp = theme.templates.imageTemp;
let twoTwoFiveSevenTemp = theme.templates.twoTwoFiveSevenTemp;
let tocTemp = theme.templates.tocTemp;
let privacyTemp = theme.templates.privacyTemp;
//let joinTemp = theme.templates.joinTemp;

// Local Templates override template
import joinTemp from './templates/join.html';
import tourTemp from './templates/tour.html';
import ccoSuccTemp from './templates/ccoSucc.html';
import ccoDecTemp from './templates/ccoDec.html';
import contactTemp from './templates/contact.html';
import affilatesTemp from './templates/affiliates.html';
import warningTemp from './templates/warning.html';

export default function routes($stateProvider, $urlRouterProvider, $locationProvider, paginationTemplateProvider) {
  'ngInject';

  $locationProvider.html5Mode(true);

  paginationTemplateProvider.setString(paginationTemp);

  $urlRouterProvider.otherwise('/warning');

  $stateProvider
    .state({
      name: 'warning',
      url: '/warning',
      template: warningTemp,
      data: {
        title: 'Welcome',
        showMenu: false
      }
    })
    .state({
      name: 'tour',
      url: '/tour',
      template: tourTemp,
      controller: 'tourCtrl',
      controllerAs: 'tour',
      data: {
        title: 'Tour',
        showMenu: true
      }
    })
    // because these states use pagination they have to be
    // controllerAs .. vm
    .state({
      name: 'updates',
      url: '/updates?:pageNum',
      template: updatesTemp,
      controller: 'updatesListCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Updates',
        showMenu: true
      }
    })
    .state({
      name: 'models',
      url: '/models?:pageNum?:order',
      template: modelsTemp,
      controller: 'modelsListCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Models',
        showMenu: true
      }
    })
    .state({
      name: 'model',
      url: '/model?:modelId?:pageNum',
      template: modelTemp,
      controller: 'modelCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Model Details',
        showMenu: true
      }
    })
    .state({
      name: 'join',
      url: '/join',
      template: joinTemp,
      data: {
        title: 'Join',
        showMenu: true
      }
    })
    .state({
      name: 'trailer',
      url: '/trailer?:updateId',
      template: trailerTemp,
      controller: 'trailerCtrl',
      controllerAs: 'trailer',
      data: {
        title: 'Trailer',
        showMenu: true
      }
    })
    .state({
      name: 'video',
      url: '/video?:updateId',
      template: videoTemp,
      controller: 'videoContentCtrl',
      controllerAs: 'vcc',
      data: {
        title: 'Members Video',
        showMenu: true
      }
    })
    .state({
      name: 'image',
      url: '/image?:videoId:imageIdx',
      template: imageTemp,
      controller: 'imageContentCtrl',
      controllerAs: 'vm',
      data: {
        title: 'Members Image',
        showMenu: true
      }
    })
    .state({
      name: '2257',
      url: '/2257',
      template: twoTwoFiveSevenTemp,
      data: {
        title: '18 U.S.C. 2257 Statement',
        showMenu: true
      }
    })
    .state({
      name: 'toc',
      url: '/toc',
      template: tocTemp,
      data: {
        title: 'Terms And Conditions',
        showMenu: true
      }
    })
    .state({
      name: 'affiliates',
      url: '/affiliates',
      template: affilatesTemp,
      data: {
        title: 'Affiliates',
        showMenu: true
      }
    })
    .state({
      name: 'privacy',
      url: '/privacy',
      template: privacyTemp,
      data: {
        title: 'Privacy',
        showMenu: true
      }
    })
    .state({
      name: 'contact',
      url: '/contact',
      template: contactTemp,
      data: {
        title: 'Contact Us',
        showMenu: true
      }
    })
    .state({
      name: 'cco_declined',
      url: '/cco_dec',
      template: ccoDecTemp,
      data: {
        title: 'Declined',
        showMenu: true
      }
    })
   .state({
      name: 'cco_success',
      url: '/cco_suc',
      template: ccoSuccTemp,
      data: {
        title: 'Approved',
        showMenu: true
      }
    })
}



// WEBPACK FOOTER //
// ./src/app/app.routes.js